import React, { useState } from 'react';
import withAnimation from '../../../hooks/withAnimation';
import { newServices } from '../../../utils/NewData';

const services = [
  'Arthritis',
  'Balance Training',
  'Gait Training',
  'Headaches',
  'Neck Pain',
  'Motor Vehicle Accidents',
  'Workplace Injuries',
  'Neurological Disorders',
  'Vertigo & Dizziness',
  'Back Pain',
  'Sciatica Pain',
  'Shoulder Pain',
  'Hip Pain',
  'Knee Pain',
  'Wrist Pain',
  'Elbow Pain',
  'Hand Pain',
  'Foot Pain',
  'Ankle Pain',
  'Sports Injuries',
  'Post-Surgical Rehabilitation',
  'Pre-Surgical Rehab',
  'Chronic Pain',
  'TMJ Dysfunction',
  'Ergonomics',
  'Vestibular Rehab',
  'Incontinence',
  'Pelvic Pain',
  'Stress Fractures',
];

const ConsultingForm = () => {
  const [agree, setAgree] = useState(false);

  const handleAgreeChange = (e) => {
    setAgree(e.target.checked);
  };

  return (
    <div className="flex bg-white flex-col items-center py-8 px-4">
      <h2 className="text-3xl text-center font-primary font-bold text-primary mb-8 lg:text-4xl">Book an Appointment Now</h2>
      <form className="w-full max-w-5xl flex flex-col lg:flex-row justify-around items-center space-y-4 lg:space-y-0">
        <input
          type="text"
          placeholder="Full Name"
          className="w-full lg:w-1/3 p-3 mx-4 border border-gray-300 rounded-full"
        />
        <input
          type="tel"
          placeholder="WhatsApp Preferred"
          className="w-full lg:w-1/3 p-3 mx-4 border border-gray-300 rounded-full"
        />
        <select className="w-full p-3 mx-4 border border-gray-300 rounded-full lg:w-1/3">
          <option>Select Category</option>
          {newServices.map((service, index) => (
            <option key={index} value={service}>
              {service}
            </option>
          ))}
        </select>
      </form>
      <div className="flex text-start items-start mt-8">
        <input
          type="checkbox"
          checked={agree}
          onChange={handleAgreeChange}
          className="form-checkbox h-5 w-5 text-primary"
        />
        <label className="ml-2 text-gray-700 font-primary">
          I have read and agree to Conklin's{' '}
          <a href="#" className="text-primary underline">Terms of Use</a> and{' '}
          <a href="#" className="text-primary underline">Privacy Policy</a>
        </label>
      </div>
      <button
        type="submit"
        className="mt-8 bg-primary text-white py-4 px-20 text-lg rounded-full font-primary font-semibold"
      >
        Book an Appointment
      </button>
    </div>
  );
};

export default withAnimation(ConsultingForm);
